import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'app-back-link',
  templateUrl: './back-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackLinkComponent {
  @Input() public page: string;
  @Input() public label: string;
  @Input() public testId: string;

}
